<div class="content">

    <div class="text-left mt-5">



        <h3>DROPBOX Batch job</h3> <br>

        <p>Batch Job submission with Dropbox.</p><br>

        <p><a class="text-muted">REQUEST BODY SCHEMA:</a> application/json</p>
        <hr><br>

        <p><b>Batch Request Body</b></p><br>


        <div class="table-responsive">
            <table class="table table-primary table-bordered">
                <tbody>

                    <tr>
                        <td>
                            <h6>paths</h6>
                        </td>
                        <td colspan="4">
                            <small>array</small>
                            <p>
                                List of files or folders to submit for optimus
                            </p>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <h6>crunch_modes</h6>
                        </td>
                        <td colspan="4">
                            <small>Array of strings</small>
                            <p>
                                Items Enum: "video_optimizer" "video_upscaler" "image_upscaler" "image_optimizer"</p>
                            <p>
                                List of allowed crunch modes
                            </p>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <h6>process_type</h6>
                        </td>
                        <td colspan="4">
                            <small>string</small>
                            <p>
                                Items Enum: "size" "quality" "1080p" "4k" "default"</p>
                            <p>
                                List of allowed process type. Video_optimizer supports [size, quality]. Video_upscaler
                                supports[1080p, 4k, default].
                            </p><br>
                            <b>Note:</b>
                            <p>We can set Ask me everytime flag true by calling /v1/customer/update. <a routerLink="/jobSettings" target="_blank">Please see refer customer update API</a>
                            </p>
                            <p>By default ask_me_every_time is set to FALSE,</p>
                            <p>1. optimizer_process_settings=>ask_me_every_time is TRUE
                                Then process_type is is mandatory for Optimiser job </p>
                            <p>2. upscaler_process_settings=>ask_me_every_time is TRUE
                                Then process_type is mandatory for Upscaler job </p>
                        </td>
                    </tr>


                    <tr>
                        <td>
                            <h6>file_management_copy_preference</h6>
                        </td>
                        <td colspan="4">
                            <small>string</small>
                            <p>
                                Items Enum: "replace_original_file" "manual_copy" "create_copy"</p>
                            <p>
                                [NOT SUPPORTED CURRENTLY] List of allowed file management copy preference
                            </p><br>

                            <b>Note:</b><br>
                            <p>We can set Ask me everytime flag true by calling /v1/customer/update. <a  routerLink="/jobSettings" target="_blank">Please see refer customer update API</a>
                            </p>
                            <p>By default ask_me_every_time is set to FALSE,</p>

                            <p>If optimizer_file_management_properties=> ask_me_every_time is TRUE
                                Then file_copy_preference value is mandatory for Optimiser job </p>

                            <p>upscaler_file_management_properties=> ask_me_every_time is TRUE then
                                file_copy_preference value is mandatory for Upscaler job
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div><br>


        <div class="card text-bg-dark mb-3">
            <div class="card-body">
                <pre><button type="button" class="btn btn-success">POST</button>  https://api.optimusdrive.ai/v1/dropbox/batch</pre>
            </div>
        </div> <br><br>


        <h5>Request samples (Video Optimizer)</h5><br>

        <div class="card text-bg-dark mb-3">
            <div class="card-body">

                <div class="card-title">
                    <button style="float: right;" *ngIf="copyButton" class="btn btn-outline-primary btn-sm" (click)="copyJsonToClipboard()">
                      <i class="fa fa-clipboard" aria-hidden="true"></i>
                    </button>
                      
                    <button style="float: right;" *ngIf="copiedButton"  class="btn btn-success btn-sm">
                      Copied <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
              
                   </div><br><br>
                   
                <p>Content type : application/json</p>
                <pre><code [innerHTML]="requestData"></code></pre>
            </div>
        </div><br><br>


        <div>

            <h5>Response samples (Video Optimizer)</h5><br>


            <div class="card text-bg-light mb-3">
                <div class="card-body">

                    <div class="panel panel-primary">
                        <div class="tab-menu-heading">
                            <ul class="nav nav-pills" role="tablist">
                                <!-- Tab menu items -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="tab1" data-bs-toggle="tab"
                                        data-bs-target="#content1" type="button" role="tab" aria-controls="content1"
                                        aria-selected="true">200</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab2" data-bs-toggle="tab" data-bs-target="#content2"
                                        type="button" role="tab" aria-controls="content2"
                                        aria-selected="false">500</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab3" data-bs-toggle="tab" data-bs-target="#tent3"
                                        type="button" role="tab" aria-controls="content3"
                                        aria-selected="false">400</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab4" data-bs-toggle="tab" data-bs-target="#content4"
                                        type="button" role="tab" aria-controls="content4"
                                        aria-selected="false">401</button>
                                </li>
                            </ul>
                        </div>

                        <div class="panel-body tabs-menu-body mt-4">
                            <div class="tab-content">
                                <!-- Tab content -->
                                <div class="tab-pane fade show active" id="content1" role="tabpanel"
                                    aria-labelledby="tab1">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="sucessData" ></code></pre>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="content2" role="tabpanel" aria-labelledby="tab2">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="Error5x" ></code></pre>
                                    </div>
                                </div>

                                <div class="tab-pane fade" id="tent3" role="tabpanel" aria-labelledby="tab3">

                                    <div class="card-body" id="content3">
                                        <pre><code [innerHTML]="Error4x" ></code></pre>
                                    </div><br>

                                    <div class="card-body" id="content3">
                                        <pre><code [innerHTML]="Error42x" ></code></pre>
                                    </div>

                                </div>


                                <div class="tab-pane fade" id="content4" role="tabpanel" aria-labelledby="tab4">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="Error401x" ></code></pre>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>



        </div>



        <br><br><h5 class="mt-5">Request samples (Image Optimizer)</h5><br>

        <div class="card text-bg-dark mb-3">
            <div class="card-body">

                <div class="card-title">
                    <button style="float: right;" *ngIf="copyButton" class="btn btn-outline-primary btn-sm" (click)="imageClipboard()">
                      <i class="fa fa-clipboard" aria-hidden="true"></i>
                    </button>
                      
                    <button style="float: right;" *ngIf="copiedButton"  class="btn btn-success btn-sm">
                      Copied <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
              
                   </div><br><br>
                   
                <p>Content type : application/json</p>
                <pre><code [innerHTML]="requestImageData"></code></pre>
            </div>
        </div><br><br>


        <div>

            <h5>Response samples (Image Optimizer)</h5><br>


            <div class="card text-bg-light mb-3">
                <div class="card-body">

                    <div class="panel panel-primary">
                        <div class="tab-menu-heading">
                            <ul class="nav nav-pills" role="tablist">
                                <!-- Tab menu items -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="tab1" data-bs-toggle="tab"
                                        data-bs-target="#item1" type="button" role="tab" aria-controls="content1"
                                        aria-selected="true">200</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab2" data-bs-toggle="tab" data-bs-target="#item2"
                                        type="button" role="tab" aria-controls="content2"
                                        aria-selected="false">500</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab3" data-bs-toggle="tab" data-bs-target="#item3"
                                        type="button" role="tab" aria-controls="content3"
                                        aria-selected="false">400</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab4" data-bs-toggle="tab" data-bs-target="#item4"
                                        type="button" role="tab" aria-controls="content4"
                                        aria-selected="false">401</button>
                                </li>
                            </ul>
                        </div>

                        <div class="panel-body tabs-menu-body mt-4">
                            <div class="tab-content">
                                <!-- Tab content -->
                                <div class="tab-pane fade show active" id="item1" role="tabpanel"
                                    aria-labelledby="tab1">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="sucessData" ></code></pre>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="item2" role="tabpanel" aria-labelledby="tab2">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="Error5x" ></code></pre>
                                    </div>
                                </div>

                                <div class="tab-pane fade" id="item3" role="tabpanel" aria-labelledby="tab3">

                                    <div class="card-body" id="content3">
                                        <pre><code [innerHTML]="Error4x" ></code></pre>
                                    </div><br>

                                    <div class="card-body" id="content3">
                                        <pre><code [innerHTML]="Error42x" ></code></pre>
                                    </div>

                                </div>


                                <div class="tab-pane fade" id="item4" role="tabpanel" aria-labelledby="tab4">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="Error401x" ></code></pre>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>



        </div>
        

    </div>